var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',_vm._b({attrs:{"formatter":_vm.formatter,"value":_vm._value,"lazy-formatter":""},on:{"focus":_vm.onfocus,"blur":_vm.onblur,"input":_vm.onUpdateValue}},'b-form-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }